import { Navigate } from "react-router-dom";

function CertificationRedirect() {
  return <Navigate to="/onboarding" replace />;
}

export default CertificationRedirect;
